export const locationKeysToStore = [
  'location',
  'latitude',
  'longitude',
  'state',
]

// Insurance is handled separately because it resets on a state change.
export const filterKeysKeptOnLocationChange = [
  'counselingType',
  'clientAgeGroup',
  'dayOfWeek',
  'timeOfDay',
  'availabilityType',
  'areaOfConcern',
  'counselingApproach',
  'language',
  'gender',
  'orderBy',
]
